module.exports = __webpack_public_path__ + "static/img/counting_new.71de560.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/counting_new.gif
// module id = Q1cx
// module chunks = 1